/*公共接口，无需鉴权 */
import { $http } from "./index";

//获取部门树
export const data_department_tree = () => {
  return $http.get("/admin/Data/getDepartment", {
    params: {
      tree: 1,
      sort_field: "sort",
      sort_value: "asc",
    },
  });
};

//获取用户分页列表
export const data_admin_page = (params) => {
  return $http.get("/admin/Data/getAdmin", { params });
};

//获取用户下拉框数据
export const data_admin_select = () => {
  return $http.get("/admin/Data/getAdmin", { params: { limit: 0 } });
};

//获取角色下拉框列表
export const data_role_select = (params) => {
  return $http.get("/admin/Data/getAdminRole", { params });
};

//获取扣缴义务人及供应商下拉框数据
export const data_withholdingagent_supplier_select = () => {
  return $http.get("/admin/Data/getWithholdingAgents");
};

//获取扣缴义务人下拉框数据
export const data_withholdingagent_select = () => {
  return $http.get("/admin/Data/getWithholdingAgent", { params: { limit: 0 } });
};

//获取扣缴义务人分页数据
export const data_withholdingagent_page = (params) => {
  return $http.get("/admin/Data/getWithholdingAgent", { params });
};

//获取（扣缴义务人/供应商）下的员工列表
export const data_withholdingagent_employee_page = (params) => {
  return $http.get("/admin/Data/getWithholdingAgentEmployee", { params });
};

//获取供应商下拉框数据
export const data_supplier_select = () => {
  return $http.get("/admin/Data/getSupplier");
};

//获取供应商分页数据
export const data_supplier_page = (params) => {
  return $http.get("/admin/Data/getSupplier", { params });
};

//获取供应商结算单位下拉框数据
export const data_settleunit_select = (supplier_id) => {
  return $http.get("/admin/Data/getSettleUnit", { params: { supplier_id } });
};

//获取客户下拉框数据
export const data_customer_select = () => {
  return $http.get("/admin/Data/getCustomer");
};

//获取客户子账户下拉框数据
export const data_customer_subaccount_select = (customer_id) => {
  return $http.get("/admin/Data/getCustomerSubaccount", {
    params: { customer_id },
  });
};

//获取签约单位下拉框数据
export const data_contractunit_select = () => {
  return $http.get("/admin/Data/getContractUnit");
};

//获取税局下拉框数据
export const data_taxbureau_select = () => {
  return $http.get("/admin/Data/getTaxBureau");
};

//获取行政区划树
export const data_areacode_tree = (return_level = 3) => {
  return $http.get("/admin/AreaCode/index", {
    params: { tree: 1, limit: 0, return_level },
  });
};

//获取行业树
export const data_industry_tree = () => {
  return $http.get("/admin/Dictionary/getIndustry", { params: { tree: 1 } });
};

//获取银行账户下拉框数据
export const data_bankaccount_select = () => {
  return $http.get("/admin/Data/getBankAccount");
};

//获取余额认领用途
export const bankcollected_other_type = () => {
  return $http.get("/admin/Dictionary/otherBankReceivedType");
};

export const data_bankreceived_type = () => {
  return $http.get("/admin/Dictionary/otherBankReceivedType");
};

//获取中国银行代发工资摘要
export const data_b2edictionary_getbocfurinfo = () => {
  return $http.get("/admin/B2eDictionary/getBocFurinfo");
};

//获取扣缴义务人下的银行账户
export const data_withholdingagent_account = (params) => {
  return $http.get("/admin/Data/getBankAccountPay", { params });
};


//获取个税申报截止日期提示信息
export const data_gettaxdeclaredatetext = (params) => {
  return $http.get("/admin/Data/getTaxDeclareDateText", { params });
};

//获取中国民生银行支付制单人
export const data_getcmbcgenerateorderuser= (params) => {
  return $http.get("/admin/B2eDictionary/getCmbcGenerateOrderUser", { params });
};